import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { KpiCard } from 'dashboard/components/common';

/** Top KPI tiles for NFT Studio: total, on-chain, drafts, failed. */
export default function NftKpiRow({ collections }) {
  const stats = useMemo(() => ({
    total:  collections.length,
    live:   collections.filter((c) => c.status === 'deployed').length,
    drafts: collections.filter((c) => c.status === 'draft').length,
    failed: collections.filter((c) => c.status === 'failed').length,
  }), [collections]);

  return (
    <Grid container spacing='12px' mb='20px'>
      <Grid item xs={6} md={3}><KpiCard label='All'      value={stats.total} /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='On chain' value={stats.live}   accent='#16a34a' /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='Drafts'   value={stats.drafts} /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='Failed'   value={stats.failed} accent='#dc2626' /></Grid>
    </Grid>
  );
}
